<template>
  <v-sheet height="100%" class="">
    <div  :class="$vuetify.breakpoint.smAndDown?'d-flex justify-center overflow-hidden':'justify-center'">
      <div style="width:100%">
        <v-img min-height="600" src="/static/logos/login_background.jpg">
          <v-row justify="center">
            <v-col cols="8">
              <v-img class="mt-5" src="/static/logos/iBook_text.svg"></v-img>
            </v-col>
            <v-col cols="12">
              <!--<v-card-title :class="$vuetify.breakpoint.smAndDown?'text-h4':'text-h2'" class="white--text font-weight-bold d-flex justify-center">iBookrestaurant</v-card-title>-->
              <v-card-title :class="$vuetify.breakpoint.mdAndDown?'text-caption':''" class=" white--text d-flex justify-center mt-n8">Your Reservations | Your Customers | Your Promotions</v-card-title>
            </v-col>
            <v-col
              cols="10"
              sm="6"
              md="4"
              lg="4"
              xl="4"
              :style="$vuetify.breakpoint.smAndDown?'margin-top:200px!important':'margin-top:300px!important'"
              class="px-2 mt-16"
            >
              <v-form
                @submit.prevent="$v.$invalid ? null : submit()"
                ref="form"
              >
                <v-text-field
                  :error-messages="fieldErrors('form.email').length>0?$t(page+'.'+fieldErrors('form.email')):null"
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"

                  ref="email"
                  persistent-placeholder
                  placeholder="Email"
                  v-model="form.email"
                  label="Email"
                  outlined
                  type="email"
                  hide-details
                  class="px-6"
                />
                <v-text-field
                  :error-messages="fieldErrors('form.password').length>0?$t(page+'.'+fieldErrors('form.password')):null"
                  :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPwd ? 'text' : 'password'"
                  @input="$v.form.password.$touch()"
                  @blur="$v.form.password.$touch()"
                  placeholder="Password"
                  persistent-placeholder
                  v-model="form.password"
                  label="Password"
                  hide-details
                  @click:append="showPwd = !showPwd"
                  outlined
                  class="px-6 py-2"
                />
                <!--<div class="text-right text-caption mt-2 px-6 mb-4 font-weight-black" style="cursor:pointer" to="/auth/forgotpassword">forgotten password?</div>-->
                <router-link
                  to="/auth/forgotpassword"
                  class="no-text-decoration text-right text-caption mt-2 px-6 mb-4 font-weight-black"
                  >{{$t(page+'.Password Forgotten')}}?
                </router-link>
                <div class="px-6">
                  <v-btn color="black" dark block ref="logButton" type="submit" :disabled="$v.$invalid" :loading="loader"
                    >{{$t(page+'.Connect')}}
                  </v-btn>
                </div>
                <!--<div class="text-center text-caption mt-6 font-weight-black" to="/auth/signup">not a member yet? sign up now!</div>-->

              </v-form>   
              <div class="text-center text-caption mt-6">Cookies Consent | Privacy Statement</div>
              <div class="text-center text-caption mt-2">2023-2025 &copy; -  iBookrestaurant</div>
              <v-row class="mt-1 px-2 py-8" :style="$vuetify.breakpoint.smAndDown?'margin-top:30px!important':'margin-top:40px!important'">
                <v-col cols="12">
                  <v-img src="/static/logos/logos.svg"></v-img>
                </v-col>      
              </v-row>
            </v-col>
          </v-row>
        </v-img>
 


      </div>
    </div>
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{$t(page+'.Signed In Successfully')}}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
    <v-dialog persistent v-model="dialog" max-width="600">
      <v-card class="">
        <v-card-title class="text-h4 error white--text"
          >{{$t(page+'.Sign In Error')}}
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab class="warning mr-6" to="/auth/forgotpassword">
                <v-icon>mdi-lock-question</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Forgot PWD')}}</span>
          </v-tooltip>           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab class="info mr-2" @click="dialog=false">
                <v-icon>mdi-form-textbox-password</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Retry')}}</span>
          </v-tooltip>   

          </v-card-title
        >
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
// Validations
import { required, email, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
const defaultForm = {
  email: "",
  password: "",
  rememberme: localStorage.getItem('settings')?JSON.parse(localStorage.getItem('settings')).rememberme:'false',
};
export default {
  mixins: [validationMixin],
  validations: {
    form: {
      email: { required, email },
      password: {
        required,
        minLength: minLength(3),
      },
    },   
  },
  validationMessages: {
    form: {
      email: {
        required: "Please enter email",
        email: "Email must be valid",
      },
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters",
      },
    }  
  },
  created(){
    //console.log(235,this.settings)
    this.$vuetify.theme.dark = false;//this.settings.options.darkTheme;
    var la=window.navigator.userLanguage||window.navigator.language;
    la='it';
    console.log(238,la)
    this.$store.dispatch("setLocale",la.substring(0,2));
    this.form.rememberme=localStorage.getItem('settings')?JSON.parse(localStorage.getItem('settings')).rememberme:false;
    console.log(241,localStorage.getItem('settings'),this.form)
    document.title = 'iBookRestaurant | login';
    //localStorage.clear();
    //sessionStorage.clear();
    //sessionStorage.removeItem('jwt');
    console.log(245,this.$route)
    console.log(246,this.$route.query);
    if (this.$route.query&&this.$route.query.token||this.$route.query&&this.$route.query.setupToken)
    {
      this.form.token=this.$route.query.token?this.$route.query.token:this.$route.query.setupToken;
      console.log(250,this.$route.query.token,this.$route.query.setupToken);
      if(this.$route.query.setupToken)
      {
        sessionStorage.setItem('setupToken',this.$route.query.setupToken)
      }
      this.submit();
    }      
  },
  data() {
    return {
      page:'Auth',
      steps: 6,
      form: Object.assign({}, defaultForm),
      form2: Object.assign({}, defaultForm),
      showPwd: false,
      snackbar: false,
      rememberme: false,
      message:'',
      dialog: false,
      loader: false,
      errorid: '0',
    };
  },
  methods: {
 
	  storageAvailable(type) {
		try {
			var storage = window[type],
				x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		}
		catch(e) {
			return false;
		}
	},
    async submit()
    {
		this.loader=true;
		if(!this.storageAvailable('localStorage'))
		{
			this.$router.push('/auth/storageissue').catch(() => {});
		}
		else
		{
      localStorage.removeItem('settings');
      sessionStorage.removeItem('settings');
      sessionStorage.removeItem('jwt');
      this.form.version=localStorage.getItem('version')
      try
      {
        const res = await this.$http.post('/auth/login.php', this.form)
        this.errorid=res.data.errorid;
        console.log(241,res);
        if (res.data.errorid=='0')
        {
          //console.log(244,this.errorid);
          //console.log(245,res.data.user);
          //console.log(246,JSON.parse(res.data.user));
          
          sessionStorage.setItem('jwt', res.data.jwt);
          localStorage.setItem('version', res.data.version);
          sessionStorage.setItem('csrf', res.data.csrf);
          let settingsforLocalStorage=res.data.settings
          delete settingsforLocalStorage.faqs;
          delete settingsforLocalStorage.requests;
          //delete settingsforLocalStorage.options;
          this.$store.dispatch("setSettings",res.data.settings);
          //this.$store.dispatch("setTempBrand",settingsforLocalStorage.brand);
          console.log(347,settingsforLocalStorage.brand)
          //this.$store.dispatch("setUser",JSON.parse(res.data.user));
          //this.$store.dispatch("setLocale", res.data.user.locale);

          if (res.data.settings)
          {
            //localStorage.setItem('settings', JSON.stringify(settingsforLocalStorage));
            sessionStorage.setItem('settings', JSON.stringify(settingsforLocalStorage))
            //let sitefwd='http://'+userforLocalStorage.hostnames.hostname+'/ajax/auth/fwd.php?user='+res.data.user+'&jwt='+res.data.jwt+'&landingPage='+userforLocalStorage.landingPage;
            //console.log(384,sitefwd);
            //window.location.href = sitefwd;
            console.log(343,settingsforLocalStorage.landingPage);
            this.$router.push(settingsforLocalStorage.landingPage).catch(() => {});
            //this.$router.push(userforLocalStorage.landingPage).catch(() => {});
          }
          else
          {
            localStorage.removeItem('settings');
            sessionStorage.removeItem('settings');
          }
          
        }
        else
        {
          this.message=res.data.message;
          this.dialog=true;
        }
		  }       
      catch(e)
      {
        this.$router.push('/auth/login').catch(() => {});
      }
		}
      this.loader=false;
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
    },
  }
};
</script>
